

import Sortable from "sortablejs"

export default {
  mounted() {
    this.enableSortable && this.mountSortable()
  },
  methods: {
    mountSortable() {
      this.instance = new Sortable(this.$refs.header, {
        handle: ".drag-handle",
        draggable: ".table-cell",
        animation: 100,
        sort: true,
        filter: ".ignore-element",

        forceFallback: true,
        fallbackOnBody: true,
        direction: "horizontal",

        onUpdate: () => {
          requestAnimationFrame(() => {
            const items = Array.from(this.$refs.header.children)
            this.$emit("update-column-order", items.map(el => el.dataset.column))
          })
        },
      })
    },
    destroySortableInstance() {
      this.instance && this.instance.destroy()
      this.instance = null
    },
  },
  computed: {
    enableSortable() {
      return this.columns && this.columns.length > 1
    },
  },
  watch: {
    enableSortable(val) {
      this.destroySortableInstance()
      val && this.mountSortable()
    },
  },
}
